import { makeStyles, shorthands } from '@fluentui/react-components';

export const useActionAssetCardsStyle = makeStyles({
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    ...shorthands.gap('16px'),
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    maxWidth: '1532px',
  },
});
